import { DefineOptionsParametersFactory } from '../../../../subject/testRunner/media/options-test';
import { Iat } from '../../types';

export const IatParametersDefinition =
  DefineOptionsParametersFactory<Iat>(true);
